import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { FormControl, FormGroup } from '@angular/forms'
import { PdfChart } from '../../shared/pdfChart'
import { CpmService } from '../../service/cpm.service'
import 'rxjs/add/operator/map'

@Component({
  selector: 'app-sector-popup-data',
  templateUrl: './sector-popup-data.component.html',
  styleUrls: ['./sector-popup-data.component.scss']
})
export class SectorPopupDataComponent implements OnInit {
  @ViewChild('sortableTable') sortableTable: any
  tradingDate
  listStockQuote = []
  dataQuaterCurrent = []
  saleTotal
  popupDataTableOptions: DataTables.Settings = {}
  dataTable = []
  dataTable2 = []
  secYear = []
  lengthOfFinAnnual
  headerQuater = []
  AnnualYearFillter = []
  listnum
  listnum2
  popupData
  listHeaderTrendAnalysis = []
  listHeaderLessThanTen = []
  popupData2
  dataProvider
  CurrentYearFillter = []
  listHeaderSec1
  saleChgF: Number
  saleChgY: Number
  profitChgF: Number
  profitChgY: Number
  retainChgF: Number
  retainChgY: Number
  debChgF: Number
  debChgY: Number
  listHeaderSec2
  endYear
  startYear
  sumData
  listCell
  headerTable1
  saleTable1
  salesTotal = []
  profitsTotal = []
  retainsTotal = []
  debsTotal = []
  salesTotal2 = []
  profitsTotal2 = []
  retainsTotal2 = []
  debsTotal2 = []
  profitTable1
  retainTable1
  deratioTable1
  radioSectorPopup1
  radioSectorPopup2
  stateRadioBtn
  sectorpopupValue1 = ''
  sectorpopupValue2 = ''
  propertyName
  last5
  last52
  sortList = []
  first5Data = []
  marketHeadipo = []
  first5Data2 = []
  dataTableForPopupdata1 = []
  expandData = []
  expandData2 = []
  totalfinStatAnnual = []
  last5show = []
  quarterData = []
  yearData = []
  last52show
  dataLessthan10 = []
  dataLessthanten = []
  print
  getPrint
  quarter
  round = '4'
  indexName
  indexLevel
  marketName
  asOf
  totalDeratio
  form: FormGroup
  pdfChart: PdfChart = new PdfChart()
  disable = true
  constructor(
    private activatedRoute: ActivatedRoute,
    private cpmService: CpmService
  ) { }

  ngOnInit() {
    const { indexN } = this.activatedRoute.snapshot.params
    const { indexL } = this.activatedRoute.snapshot.params
    const { marketL } = this.activatedRoute.snapshot.params

    this.propertyName = true
    const { radioByView } = this.activatedRoute.snapshot.params
    const { radioByFinancial } = this.activatedRoute.snapshot.params
    const { pdf } = this.activatedRoute.snapshot.data
    const { print } = this.activatedRoute.snapshot.data
    this.getPrint = print
    this.pdfChart.setPdf(pdf)
    this.print = print
    this.indexName = indexN ? indexN : 'ALL'
    this.indexLevel = indexL ? indexL : 'ALL'
    this.marketName = marketL ? marketL : 'ALL'

    radioByView === undefined
      ? (this.sectorpopupValue1 = 'top')
      : (this.sectorpopupValue1 = radioByView)
    radioByFinancial === undefined
      ? (this.sectorpopupValue2 = 'sale')
      : (this.sectorpopupValue2 = radioByFinancial)

    this.radioSectorPopup1 = [
      { value: 'top', des: 'Top ranked companies' },
      { value: 'trend', des: 'Trend analysis' }
    ]

    this.radioSectorPopup2 = [
      { value: 'sale', des: 'Sales' },
      { value: 'profit', des: 'Profits' },
      { value: 'retainEarning', des: 'Retain earnings' },
      { value: 'deRatio', des: 'Debt to equity ratio' }
    ]

    this.form = new FormGroup({
      radioByView: new FormControl(this.sectorpopupValue1),
      radioByFinancial: new FormControl(this.sectorpopupValue2)
    })

    localStorage.setItem('printSectorPopup', 'false')
    this.getLastTradingDate().then(endYear =>
      this.loadDataFromGetLastTradingDate(endYear)
    )
  }
  loadDataFromGetLastTradingDate(endYear) {
    this.endYear = endYear
    this.startYear = +this.endYear - 4
    this.onChangeData()
  }

  async onChangeData() {
    this.dataQuaterCurrent = []

    this.dataLessthan10 = []
    this.dataLessthanten = []
    this.first5Data2 = [];
    this.expandData2 = []
    this.last52show = []
    this.dataTable2 = []
    this.last5show = []
    this.CurrentYearFillter = []
    this.AnnualYearFillter = []
    this.last5 = []
    this.first5Data = []
    this.popupData = []
    this.popupData2 = []
    this.totalfinStatAnnual = []
    this.sectorpopupValue1 === 'top'
      ? (this.propertyName = true)
      : (this.propertyName = false)
    this.listHeaderSec1 = [
      'No.',
      'Securities',
      'Sale (M.Baht)',
      'Securities',
      'Profits (M.Baht)',
      'Securities',
      'Retain earnings (M.Baht)',
      'Securities',
      'D/E ratio (x)'
    ]
    this.listHeaderTrendAnalysis = ['No.', 'Securities']
    this.listHeaderLessThanTen = ['No.', 'Securities']
    this.popupData = []
    this.popupData = await this.cpmService
      .getSecurityFinancialStatistic(
        this.quarter,
        this.round,
        this.indexName,
        this.marketName,
        this.indexLevel
      )
      .then(obj => {
        return obj
      })

    this.sortList = [];
    this.sortList = this.changeData(this.popupData);

    this.sortList.map((obj, i) => {
      const data = {
        num: i + 1,
        sale: obj.sale,
        salesValue: (obj.salesValue),
        profit: obj.profit,
        profitValue: (obj.profitValue),
        retainEarning: obj.retainEarning,
        retainEarningValue: (obj.retainEarningValue),
        deRatio: obj.deRatio,
        deRatioValue: obj.deRatioValue
      }
      this.dataLessthan10.push(data)
    })

    this.sortList.map((j, i) => {
      if (i <= 4) {
        const t = {
          num: i + 1,
          sale: j.sale,
          salesValue: (j.salesValue),
          profit: j.profit,
          profitValue: (j.profitValue),
          retainEarning: j.retainEarning,
          retainEarningValue: (j.retainEarningValue),
          deRatio: j.deRatio,
          deRatioValue: j.deRatioValue
        }
        this.first5Data.push(t)
      }
    })

    this.listnum = this.sortList.length - 4
    this.last5 = this.lastarray(this.sortList)
    this.last5.map((j, i) => {
      const t = {
        num: this.listnum + i,
        sale: j.sale,
        salesValue: (j.salesValue),
        profit: j.profit,
        profitValue: (j.profitValue),
        retainEarning: j.retainEarning,
        retainEarningValue: (j.retainEarningValue),
        deRatio: j.deRatio,
        deRatioValue: j.deRatioValue
      }
      this.last5show.push(t)
    })
    this.expandData = []
    this.sortList.map((obj, i) => {
      if (i >= 5 && i <= this.listnum - 2) {
        const t = {
          num: i + 1,
          sale: obj.sale,
          salesValue: (obj.salesValue),
          profit: obj.profit,
          profitValue: (obj.profitValue),
          retainEarning: obj.retainEarning,
          retainEarningValue: (obj.retainEarningValue),
          deRatio: obj.deRatio,
          deRatioValue: obj.deRatioValue
        }
        this.expandData.push(t)
      }
    })

    const name = this.sectorpopupValue2
    this.dataTable = []

    this.popupData.map((obj, i) => {
      this.quarterData.push(obj.marketQuarter)   // obj.marketQuarter // Quarter
      if (obj.finStatCurrent === null) {
        obj.finStatCurrent = [{
          deRatio: null,
          netProfit: null,
          quarter: obj.marketQuarter,
          retainEarning: null,
          sale: null,
          year: obj.marketYear
        }]
      }

      obj.finStatCurrent.map(objYearCurrent => {
        this.CurrentYearFillter.push(objYearCurrent.year)
      })

      this.CurrentYearFillter = this.CurrentYearFillter.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])
      this.CurrentYearFillter = this.CurrentYearFillter.sort()

      obj.finStatAnnual.map(objYearAnnual => {
        this.AnnualYearFillter.push(objYearAnnual.year)
      })
      this.AnnualYearFillter = this.AnnualYearFillter.reduce(function (a, b) {
        if (a.indexOf(b) < 0) {
          a.push(b)
        }
        return a
      }, [])
      this.AnnualYearFillter = this.AnnualYearFillter.sort()

      const finance1 = obj.finStatAnnual.map(financeObj => {
        if (name === 'sale' || name === 'retainEarning') {
          const financeData = {
            year: financeObj.year,
            value: this.handleNoFinStat(financeObj, name)
          }
          return financeData
        } else if (name === 'profit') {
          const financeData = {
            year: financeObj.year,
            value: this.handleNoFinStat(financeObj, name)
          }
          return financeData
        } else if (name === 'deRatio') {
          const financeData = {
            year: financeObj.year,
            value: this.handleNoFinStat(financeObj, name)
          }
          return financeData
        }
      })

      let finance2
      if (obj.finStatCurrent !== null) {
        finance2 = obj.finStatCurrent.map(financeObj => {
          if (name === 'sale' || name === 'retainEarning') {
            const financeData2 = {
              year: financeObj.year,
              value: this.handleNoFinStat(financeObj, name)
            }
            return financeData2
          } else if (name === 'profit') {
            const financeData2 = {
              year: financeObj.year,
              value: this.handleNoFinStat(financeObj, name)
            }
            return financeData2
          } else if (name === 'deRatio') {
            const financeData2 = {
              year: financeObj.year,
              value: this.handleNoFinStat(financeObj, name)
            }

            return financeData2
          }
        })

      }

      const dataT = {
        num: i + 1,
        securitySymbol: obj.securitySymbol,
        financeAnnual: obj.finStatAnnual,
        financeCurrent: obj.finStatCurrent,
        finance1: finance1,
        finance2: finance2,
        saleChgFullYear: !!obj.saleChgFullYear ? obj.saleChgFullYear : 0,
        saleChgYoy: !!obj.saleChgYoy ? obj.saleChgYoy : 0,
        profitChgFullYear: !!obj.profitChgFullYear ? obj.profitChgFullYear : 0,
        profitChgYoy: !!obj.profitChgYoy ? obj.profitChgYoy : 0,
        retainEarningChgFullYear: !!obj.retainEarningChgFullYear ? obj.retainEarningChgFullYear : 0,
        retainEarningChgYoy: !!obj.retainEarningChgYoy ? obj.retainEarningChgYoy : 0,
        deChgFullYear: obj.deChgFullYear,
        deChgYoy: obj.deChgFullYear,
        quarter: obj.marketQuarter,
        year: obj.marketYear,
        financeSort: obj.finance2,
        finlast2Year: []
      }

      this.dataTable.push(dataT)
      this.dataLessthanten.push(dataT)
    })

    this.dataTable.map(obj => {
      const listAnn = []
      listAnn.push(...obj.financeAnnual)
      this.AnnualYearFillter.map(headerObj => {
        const annual = listAnn.find(AnnualObj => AnnualObj.year === headerObj)
        if (annual === undefined) {
          obj.financeAnnual.push({
            year: headerObj,
            quarter: 4,
            sale: 0,
            profit: 0,
            retainEarning: 0,
            deRatio: 0
          })
          obj.finance1.push({ year: headerObj, value: null })
        }
      })

      obj.financeAnnual.sort(function (a, b) {
        return a.year - b.year
      })

      const listCurr = []
      listCurr.push(...obj.financeCurrent)
      this.CurrentYearFillter.map(headerObj => {
        const current = listCurr.find(
          currentObj => currentObj.year === headerObj
        )
        if (current === undefined) {
          obj.financeCurrent.push({
            year: headerObj,
            quarter: this.quarterData[0],
            sale: 0,
            profit: 0,
            retainEarning: 0,
            deRatio: 0
          })
          obj.finance2.push({ year: headerObj, value: null })
        }
      })

      obj.financeCurrent.sort(function (a, b) {
        return a.year - b.year
      })

      obj.finance1.sort(function (a, b) {
        return a.year - b.year
      })

      obj.finance2.sort(function (a, b) {
        return a.year - b.year
      })

      if (obj.finance2.length > 1) {
        obj.finlast2Year = [
          obj.finance2[obj.finance2.length - 2].value,
          obj.finance2[obj.finance2.length - 1].value
        ]
        obj.financeSort =
          obj.finlast2Year[1] === null ? -999999 : +obj.finlast2Year[1]
      }
    })

    if (
      this.sectorpopupValue2 === 'sale' ||
      this.sectorpopupValue2 === 'profit' ||
      this.sectorpopupValue2 === 'retainEarning'
    ) {
      this.dataTable.sort(function (a, b) {
        return b.financeSort - a.financeSort
      })
      this.dataLessthanten.sort(function (a, b) {
        return b.financeSort - a.financeSort
      })
    } else {
      this.dataTable.sort(function (a, b) {
        return a.financeSort - b.financeSort
      })
      this.dataLessthanten.sort(function (a, b) {
        return a.financeSort - b.financeSort
      })
    }

    this.listHeaderTrendAnalysis.push(...this.AnnualYearFillter)
    this.listHeaderLessThanTen.push(...this.AnnualYearFillter)
    this.listHeaderTrendAnalysis.push(
      'Y' + this.AnnualYearFillter[2] + '/' + this.AnnualYearFillter[1] + ' (%yoy)'
    )
    this.listHeaderLessThanTen.push(
      'Y' + this.AnnualYearFillter[2] + '/' + this.AnnualYearFillter[1] + ' (%yoy)'
    )
    if (!this.quarterData.indexOf(1)) {
      if (this.CurrentYearFillter.length === 4) {
        this.listHeaderTrendAnalysis.push('3M ' + this.CurrentYearFillter[2])
        this.listHeaderTrendAnalysis.push('3M ' + this.CurrentYearFillter[3])
      } else if (this.CurrentYearFillter.length !== 4) {
        this.listHeaderTrendAnalysis.push('3M ' + this.CurrentYearFillter[1])
        this.listHeaderTrendAnalysis.push('3M ' + this.CurrentYearFillter[2])
      }
    } else if (!this.quarterData.indexOf(2)) {
      if (this.CurrentYearFillter.length === 4) {
        this.listHeaderTrendAnalysis.push('6M ' + this.CurrentYearFillter[2])
        this.listHeaderTrendAnalysis.push('6M ' + this.CurrentYearFillter[3])
      } else if (this.CurrentYearFillter.length !== 4) {
        this.listHeaderTrendAnalysis.push('6M ' + this.CurrentYearFillter[1])
        this.listHeaderTrendAnalysis.push('6M ' + this.CurrentYearFillter[2])
      }
    } else if (!this.quarterData.indexOf(3)) {
      if (this.CurrentYearFillter.length === 4) {
        this.listHeaderTrendAnalysis.push('9M ' + this.CurrentYearFillter[2])
        this.listHeaderTrendAnalysis.push('9M ' + this.CurrentYearFillter[3])
      } else if (this.CurrentYearFillter.length !== 4) {
        this.listHeaderTrendAnalysis.push('9M ' + this.CurrentYearFillter[1])
        this.listHeaderTrendAnalysis.push('9M ' + this.CurrentYearFillter[2])
      }
    }
    if (this.listHeaderTrendAnalysis.length == 6) this.asOf = "12M " + this.listHeaderTrendAnalysis[this.listHeaderTrendAnalysis.length - 2]
    else this.asOf = this.listHeaderTrendAnalysis[this.listHeaderTrendAnalysis.length - 1]
    this.listHeaderTrendAnalysis.push('Change (%yoy)')

    // this.first5Data2 = [];

    this.dataTable.map(obj => {

      this.quarterData.push(obj.quarter);
      this.yearData.push(obj.year)

      obj.financeAnnual.map(finance => {
        this.marketHeadipo.push(finance.year)
      })
    })
    this.quarterData = this.quarterData.reduce(function (a, b) {
      if (a.indexOf(b) < 0) {
        a.push(b)
      }
      return a
    }, [])
    this.yearData = this.yearData.reduce(function (a, b) {
      if (a.indexOf(b) < 0) {
        a.push(b)
      }
      return a
    }, [])

    this.marketHeadipo = this.marketHeadipo.reduce(function (a, b) {
      if (a.indexOf(b) < 0) {
        a.push(b)
      }
      return a
    }, [])
    this.marketHeadipo.sort((a, b) => a - b)
    this.dataTable.map((j, i) => {

      if (i <= 4) {

        const financeAnnual = j.financeAnnual.sort(
          (a, b) => (a.year < b.year ? -1 : a.year > b.year ? 1 : 0)
        )
        const finAnnual = j.finance1.sort(
          (a, b) => (a.year < b.year ? -1 : a.year > b.year ? 1 : 0)
        )
        const t = {
          num: i + 1,
          securitySymbol: j.securitySymbol,
          financeAnnual: financeAnnual,
          financeCurrent: j.financeCurrent,
          saleChgFullYear: j.saleChgFullYear,
          saleChgYoy: j.saleChgYoy,
          profitChgFullYear: j.profitChgFullYear,
          profitChgYoy: j.profitChgYoy,
          retainEarningChgFullYear: j.retainEarningChgFullYear,
          retainEarningChgYoy: j.retainEarningChgYoy,
          deChgFullYear: j.deChgFullYear,
          deChgYoy: j.deChgYoy,
          finAnnual: finAnnual,
          finCur: j.finance2,
          finCurrent: j.finlast2Year
        }

        this.first5Data2.push(t)
      } else {
        return;
      }

    })


    this.listnum2 = this.dataTable.length - 4
    this.dataTable.map((j, i) => {
      if (i >= 5 && i <= this.listnum2 - 2) {
        const financeAnnual = j.financeAnnual.sort(
          (a, b) => (a.year < b.year ? -1 : a.year > b.year ? 1 : 0)
        )
        const finAnnual = j.finance1.sort(
          (a, b) => (a.year < b.year ? -1 : a.year > b.year ? 1 : 0)
        )
        const t = {
          num: i + 1,
          securitySymbol: j.securitySymbol,
          financeAnnual: financeAnnual,
          financeCurrent: j.financeCurrent,
          saleChgFullYear: j.saleChgFullYear,
          saleChgYoy: j.saleChgYoy,
          profitChgFullYear: j.profitChgFullYear,
          profitChgYoy: j.profitChgYoy,
          retainEarningChgFullYear: j.retainEarningChgFullYear,
          retainEarningChgYoy: j.retainEarningChgYoy,
          deChgFullYear: j.deChgFullYear,
          deChgYoy: j.deChgYoy,
          finAnnual: finAnnual,
          finCur: j.finance2,
          finCurrent: j.finlast2Year
        }
        this.expandData2.push(t)
      }
    })

    this.listnum2 = this.dataTable.length - 4
    this.last52 = this.lastarray(this.dataTable)
    this.last52.map((data, i) => {
      const t = {
        num: this.listnum2 + i,
        securitySymbol: data.securitySymbol,
        financeAnnual: data.financeAnnual.sort(
          (a, b) => (a.year < b.year ? -1 : a.year > b.year ? 1 : 0)
        ),
        financeCurrent: data.financeCurrent,
        saleChgFullYear: data.saleChgFullYear,
        saleChgYoy: data.saleChgYoy,
        profitChgFullYear: data.profitChgFullYear,
        profitChgYoy: data.profitChgYoy,
        retainEarningChgFullYear: data.retainEarningChgFullYear,
        retainEarningChgYoy: data.retainEarningChgYoy,
        deChgFullYear: data.deChgFullYear,
        deChgYoy: data.deChgYoy,
        finAnnual: data.finance1.sort(
          (a, b) => (a.year < b.year ? -1 : a.year > b.year ? 1 : 0)
        ),
        finCur: data.finance2,
        finCurrent: data.finlast2Year
      }
      this.last52show.push(t)
    })


    this.first5Data2 = this.setChgyoy(this.first5Data2);
    this.expandData2 = this.setChgyoy(this.expandData2);
    this.last52show = this.setChgyoy(this.last52show);

    this.popupData2 = await this.cpmService
      .getIndustryStatisticBySec(
        this.indexName,
        this.marketName,
        this.indexLevel
      )
      .then(obj => {
        return obj
      })
    this.dataTableForPopupdata1 = [];

    this.popupData2.map(data => {
      data.finStatCurrent = this.setfinStatCurrent(this.CurrentYearFillter, data.finStatCurrent);
      let last_element = data.finStatCurrent[data.finStatCurrent.length - 1];
      if (last_element.quarter === null) {
        last_element = data.finStatAnnual[data.finStatAnnual.length - 1];
      }
      this.dataTableForPopupdata1.push(last_element);
    })

    this.saleTable1 = this.dataTableForPopupdata1.map(saleT1 => saleT1.sale)
    this.profitTable1 = this.dataTableForPopupdata1.map(
      profitT1 => profitT1.profit
    )
    this.retainTable1 = this.dataTableForPopupdata1.map(
      retainT1 => retainT1.retainEarning
    )
    this.deratioTable1 = this.dataTableForPopupdata1.map(
      deratioT1 => deratioT1.deRatio
    )
    const withCommas = Number(this.saleTable1)
    const withCommas2 = Number(this.profitTable1)
    const withCommas3 = Number(this.retainTable1)
    const withCommas4 = Number(parseFloat(this.deratioTable1));

    this.totalfinStatAnnual.push(
      withCommas,
      '',
      withCommas2,
      '',
      withCommas3,
      ''
    )
    this.totalDeratio = withCommas4
    // const name2 = this.sectorpopupValue2
    const name2 = this.sectorpopupValue2
    this.dataTable = []
    this.popupData2.map(obj => {

      const finance1 = obj.finStatAnnual.map((financeObj, i) => {
        if (
          name2 === 'sale' ||
          name2 === 'retainEarning' ||
          name2 === 'profit'
        ) {
          const financeData = {
            year: financeObj.year,
            value: financeObj[name2]
          }
          return financeData
        } else if (name2 === 'deRatio') {
          const financeData = {
            year: financeObj.year,
            value: financeObj[name2]
          }
          return financeData
        }
      })

      const finance2 = obj.finStatCurrent.map(financeObj => {
        if (
          name2 === 'sale' ||
          name2 === 'retainEarning' ||
          name2 === 'profit'
        ) {
          const financeData2 = {
            year: financeObj.year,
            value: financeObj[name2]
          }
          return financeData2
        } else if (name2 === 'deRatio') {
          const financeData2 = {
            year: financeObj.year,
            value: financeObj[name2]
          }
          return financeData2
        }
      })

      const dataP = {
        financeAnnual: obj.finStatAnnual,
        financeCurrent: obj.finStatCurrent,
        finance1: finance1,
        finance2: finance2,
        saleChgFullYear: obj.saleChgFullYear,
        saleChgYoy: !!obj.saleChgYoy ? obj.saleChgYoy : 0,
        profitChgFullYear: obj.profitChgFullYear,
        profitChgYoy: !!obj.profitChgYoy ? obj.profitChgYoy : 0, // obj.profitChgYoy,
        retainEarningChgFullYear: obj.retainEarningChgFullYear,
        retainEarningChgYoy: !!obj.retainEarningChgYoy ? obj.retainEarningChgYoy : 0,  // obj.retainEarningChgYoy,
        deChgFullYear: obj.deChgFullYear,
        deChgYoy: !!obj.deRatioChgYoy ? obj.deRatioChgYoy : 0,  //  obj.deRatioChgYoy
      }
      this.dataTable2.push(dataP)
    })


    this.saleChgF = Number(this.dataTable2.map(
      saleF => +saleF.saleChgFullYear
    ))
    this.saleChgY = Number(this.dataTable2.map(
      saleF => +saleF.saleChgYoy
    ))
    this.profitChgF = Number(this.dataTable2.map(
      saleF => +saleF.profitChgFullYear
    ))
    this.profitChgY = Number(this.dataTable2.map(
      saleF => +saleF.profitChgYoy
    ))
    this.retainChgF = Number(this.dataTable2.map(
      saleF => +saleF.retainEarningChgFullYear
    ))
    this.retainChgY = Number(this.dataTable2.map(
      saleF => +saleF.retainEarningChgYoy
    ))
    this.debChgF = Number(this.dataTable2.map(
      saleF => saleF.deChgFullYear
    ))
    this.debChgY = Number(this.dataTable2.map(
      saleF => saleF.deRatioChgYoy
    ))

    this.dataTable2.map(header => {
      this.headerQuater = header.finance2.map(obj => {
        return obj.year
      })
    })


    this.salesTotal = []
    this.dataTable2.map(saleT1 => {
      saleT1.finance1.map(obj => {

        this.salesTotal.push(obj.value)
      })
    })
    if (this.salesTotal.length == 0) {
      this.salesTotal.push(null);
      this.salesTotal.push(null);
      this.salesTotal.push(null);
    }
    this.profitsTotal = []
    this.dataTable2.map(profitT1 => {
      profitT1.finance1.map(obj => {
        this.profitsTotal.push(obj.value)
      })
    })
    if (this.profitsTotal.length == 0) {
      this.profitsTotal.push(null);
      this.profitsTotal.push(null);
      this.profitsTotal.push(null);
    }
    this.retainsTotal = []
    this.dataTable2.map(retainT1 => {
      retainT1.finance1.map(obj => {
        this.retainsTotal.push(obj.value)
      })
    })
    if (this.retainsTotal.length == 0) {
      this.retainsTotal.push(null);
      this.retainsTotal.push(null);
      this.retainsTotal.push(null);
    }
    this.debsTotal = []
    this.dataTable2.map(deratioT1 => {
      deratioT1.finance1.map(obj => {
        this.debsTotal.push(obj.value)
      })
    })
    if (this.debsTotal.length == 0) {
      this.debsTotal.push(null);
      this.debsTotal.push(null);
      this.debsTotal.push(null);
    }
    this.salesTotal2 = []

    this.dataTable2.map(saleT1 => {
      saleT1.finance2.map(obj => {
        this.salesTotal2.push(obj.value)
      })
    })
    if (this.salesTotal2.length == 0) {
      this.salesTotal2.push(null);
      this.salesTotal2.push(null);
    }
    this.profitsTotal2 = []
    this.dataTable2.map(profitT1 => {
      profitT1.finance2.map(obj => {
        this.profitsTotal2.push(obj.value)
      })
    })
    if (this.profitsTotal2.length == 0) {
      this.profitsTotal2.push(null);
      this.profitsTotal2.push(null);
    }
    this.retainsTotal2 = []
    this.dataTable2.map(retainT1 => {
      retainT1.finance2.map(obj => {
        this.retainsTotal2.push(obj.value)
      })
    })
    if (this.retainsTotal2.length == 0) {
      this.retainsTotal2.push(null);
      this.retainsTotal2.push(null);
    }
    this.debsTotal2 = []
    this.dataTable2.map(deratioT1 => {

      deratioT1.finance2.map(obj => {
        this.debsTotal2.push(obj.value)
      })
    })
    if (this.debsTotal2.length == 0) {
      this.debsTotal2.push(null);
      this.debsTotal2.push(null);
    }
  }

  lastarray(arr: any) {
    return arr.slice(Math.max(arr.length - 5, 1))
  }

  getClassHidden(index) {
    const start = 4
    const end = this.popupData.length - 6

    const re = start < index && index <= end ? false : true
    return re
  }
  changedExent(event) {
    $(event.target).parents().next('.hide').toggle()
  }

  handleNoFinStat(data, type) {
    if (this.indexLevel == 'SET' && data.sectorName == 'NPG') return '(NPG)';
    else if (data.listedStatus || this.indexLevel == 'ALL' || (this.indexLevel == data.marketName && this.indexName == data.marketName) || (this.indexLevel == data.industryName && this.indexName == data.marketName) || (this.indexLevel == data.sectorName && this.indexName == data.marketName)) {
      if (type == 'sale') return data.listedStatus ? "("+data.listedStatus+")" : data.sale;
      if (type == 'profit') return data.listedStatus ? "("+data.listedStatus+")" : data.netProfit;
      if (type == 'retainEarning') return data.listedStatus ? "("+data.listedStatus+")" : data.retainEarning;
      if (type == 'deRatio') return data.listedStatus ? "("+data.listedStatus+")" : data.deRatio;
    } 
    else if (data.sectorName == 'NPG') return '(NPG)';
    else {
      let otherIndexName = data.marketName;
      if (data.industryName) otherIndexName = otherIndexName + " - " + data.industryName;
      if (data.marketName != 'mai' && data.sectorName) otherIndexName = otherIndexName + " - " + data.sectorName;
      return "("+otherIndexName+")";
    }
  }

  changeData(popupList) {

    let listSales = []
    let listProfit = []
    let listretainEarning = []
    let listdeRatio = []
    const listPop = popupList.map(obj => {

      if (!obj.finStatCurrent.find(finstat => finstat.year === obj.marketYear)) {
        obj.finStatCurrent.push({
          deRatio: 0,
          netProfit: 0,
          quarter: obj.marketQuarter,
          retainEarning: 0,
          sale: 0,
          year: obj.marketYear
        })
      }

      let finance = []
      finance = obj.finStatCurrent
      finance = finance.sort(
        (a, b) => (a.year < b.year ? -1 : a.year > b.year ? 1 : 0)
      )
      let i

      if (finance) {
        i = finance.length - 1;
        const objx = {}
        let lastYear
        Object.keys(obj).map(kay => {
          objx[kay] = obj[kay]
          lastYear = obj['finStatCurrent'][i]
          objx['sale'] = this.handleNoFinStat(lastYear, 'sale');
          objx['profit'] = this.handleNoFinStat(lastYear, 'profit');
          objx['retainEarning'] = this.handleNoFinStat(lastYear, 'retainEarning');
          objx['deRatio'] = this.handleNoFinStat(lastYear, 'deRatio');
        })
        listSales.push(objx)
        listProfit.push(objx)
        listretainEarning.push(objx)
        listdeRatio.push(objx)
        return objx
      }
    })

    listSales = listSales.sort(function (a, b) {
      if (a.sale > b.sale) {
        return -1;
      } else if (a.sale < b.sale) {
        return 1;
      } else if (a.sale === b.sale) { // a.sale == b.sale
        if (a.securitySymbol < b.securitySymbol) {
          return -1;
        } else if (a.securitySymbol > b.securitySymbol) {
          return 1;
        } else {
          return 0;
        }
      }
    })

    listProfit = listProfit.sort(function (a, b) {
      if (a.profit > b.profit) {
        return -1;
      } else if (a.profit < b.profit) {
        return 1;
      } else { // keyA == keyB
        if (a.securitySymbol < b.securitySymbol) {
          return -1;
        } else if (a.securitySymbol > b.securitySymbol) {
          return 1;
        } else {
          return 0;
        }
      }
    })

    listretainEarning = listretainEarning.sort(function (a, b) {
      if (a.retainEarning > b.retainEarning) {
        return -1;
      } else if (a.retainEarning < b.retainEarning) {
        return 1;
      } else { // keyA == keyB
        if (a.securitySymbol < b.securitySymbol) {
          return -1;
        } else if (a.securitySymbol > b.securitySymbol) {
          return 1;
        } else {
          return 0;
        }
      }
    })

    listdeRatio = listdeRatio.sort(function (a, b) {
      if (a.deRatio < b.deRatio) {
        return -1;
      } else if (a.deRatio > b.deRatio) {
        return 1;
      } else { // keyA == keyB
        if (a.securitySymbol < b.securitySymbol) {
          return -1;
        } else if (a.securitySymbol > b.securitySymbol) {
          return 1;
        } else {
          return 0;
        }
      }
    })

    const sortList = []

    listSales = listSales.filter(s => 
      s.finStatCurrent[s.finStatCurrent.length-1].missingItem === null
    );
    listProfit = listProfit.filter(s => 
      s.finStatCurrent[s.finStatCurrent.length-1].missingItem === null
    );
    listretainEarning = listretainEarning.filter(s => 
      s.finStatCurrent[s.finStatCurrent.length-1].missingItem === null
    );
    listdeRatio = listdeRatio.filter(s => 
      s.finStatCurrent[s.finStatCurrent.length-1].missingItem === null
    );

    for (let i = 0; i < listSales.length; i++) {
      const sortObj = {
        sale: listSales[i].securitySymbol,
        salesValue: listSales[i].sale,

        profit: listProfit[i].securitySymbol,
        profitValue: listProfit[i].profit,

        retainEarning: listretainEarning[i].securitySymbol,
        retainEarningValue: listretainEarning[i].retainEarning,

        deRatio: listdeRatio[i].securitySymbol,
        deRatioValue: listdeRatio[i].deRatio
      }
      sortList.push(sortObj)
    }

    const end = sortList.length - 5
    const list = []
    const list2 = []
    for (let i = 0; i < sortList.length; i++) {
      if (i < 5) {
        list.push({ index: i, list: sortList[i] })
      } else if (i >= end) {
        list.push({ index: i, list: sortList[i] })
      } else {
        list2.push({ index: i, list: sortList[i] })
      }
    }

    return sortList
  }

  exportExcelTopRankCompany() {
    const ws_data = []
    const totalfinStatAnnualExcel = []
    ws_data.push([this.marketName + ' : ' + this.indexLevel])
    ws_data.push(this.listHeaderSec1)
    if (this.popupData.length > 10) {
      this.first5Data.map(obj => {
        const de = [
          obj.num,
          obj.sale,
          obj.salesValue === 0 ? null : obj.salesValue,
          obj.profit,
          obj.profitValue === 0 ? null : obj.profitValue,
          obj.retainEarning,
          obj.retainEarningValue === 0 ? null : obj.retainEarningValue,
          obj.deRatio,
          obj.deRatioValue === 0 ? null : obj.deRatioValue
        ]
        ws_data.push(de)
      })
      this.expandData.map(obj => {
        const de = [
          obj.num,
          obj.sale,
          obj.salesValue === 0 ? null : obj.salesValue,
          obj.profit,
          obj.profitValue === 0 ? null : obj.profitValue,
          obj.retainEarning,
          obj.retainEarningValue === 0 ? null : obj.retainEarningValue,
          obj.deRatio,
          obj.deRatioValue === 0 ? null : obj.deRatioValue
        ]
        ws_data.push(de)
      })
      this.last5show.map(obj => {
        const de = [
          obj.num,
          obj.sale,
          obj.salesValue === 0 ? null : obj.salesValue,
          obj.profit,
          obj.profitValue === 0 ? null : obj.profitValue,
          obj.retainEarning,
          obj.retainEarningValue === 0 ? null : obj.retainEarningValue,
          obj.deRatio,
          obj.deRatioValue === 0 ? null : obj.deRatioValue
        ]
        ws_data.push(de)
      })
    } else if (this.popupData.length <= 10) {
      this.dataLessthan10.map(obj => {
        const de = [
          obj.num,
          obj.sale,
          obj.salesValue === 0 ? null : obj.salesValue,
          obj.profit,
          obj.profitValue === 0 ? null : obj.profitValue,
          obj.retainEarning,
          obj.retainEarningValue === 0 ? null : obj.retainEarningValue,
          obj.deRatio,
          obj.deRatioValue === 0 ? null : obj.deRatioValue
        ]
        ws_data.push(de)
      })
    }
    totalfinStatAnnualExcel.push(' ', 'Total')
    // const de = [this.totalfinStatAnnual];
    this.totalfinStatAnnual.map(obj => {
      totalfinStatAnnualExcel.push(obj)
    })
    totalfinStatAnnualExcel.push(this.totalDeratio)
    ws_data.push(totalfinStatAnnualExcel)
    return ws_data
  }

  exportExcelTrendAnalysis() {
    if (!this.quarterData.indexOf(1) || !this.quarterData.indexOf(2) || !this.quarterData.indexOf(3)) {
      const ws_data = []
      const listSectorHeader = []
      listSectorHeader.push(...[this.marketName + ' : ' + this.indexLevel])
      ws_data.push([...listSectorHeader])

      const listFinancialHeader = []
      if (this.sectorpopupValue2 === 'sale') {
        listFinancialHeader.push(...['Financial : Sales (M.Baht)'])
      } else if (this.sectorpopupValue2 === 'profit') {
        listFinancialHeader.push(...['Financial : Profits (M.Baht)'])
      } else if (this.sectorpopupValue2 === 'retainEarning') {
        listFinancialHeader.push(...['Financial : Retain earnings (M.Baht)'])
      } else if (this.sectorpopupValue2 === 'deRatio') {
        listFinancialHeader.push(...['Financial : Debt to equity ratio (x)'])
      }
      ws_data.push([...listFinancialHeader])

      const listDataHeader = []
      listDataHeader.push(['No.'], ['Securities'])
      this.marketHeadipo.map(obj => {
        listDataHeader.push([obj])
      })
      listDataHeader.push([
        'Y' +
        this.marketHeadipo[this.marketHeadipo.length - 1] +
        '/' +
        this.marketHeadipo[this.marketHeadipo.length - 2] +
        ' (%yoy)'
      ])

      if (!this.quarterData.indexOf(1)) {
        if (this.CurrentYearFillter.length === 4) {
          listDataHeader.push('3M ' + this.CurrentYearFillter[2])
          listDataHeader.push('3M ' + this.CurrentYearFillter[3])
        } else if (this.CurrentYearFillter.length !== 4) {
          listDataHeader.push('3M ' + this.CurrentYearFillter[1])
          listDataHeader.push('3M ' + this.CurrentYearFillter[2])
        }
      } else if (!this.quarterData.indexOf(2)) {
        if (this.CurrentYearFillter.length === 4) {
          listDataHeader.push('6M ' + this.CurrentYearFillter[2])
          listDataHeader.push('6M ' + this.CurrentYearFillter[3])
        } else if (this.CurrentYearFillter.length !== 4) {
          listDataHeader.push('6M ' + this.CurrentYearFillter[1])
          listDataHeader.push('6M ' + this.CurrentYearFillter[2])
        }
      } else if (!this.quarterData.indexOf(3)) {
        if (this.CurrentYearFillter.length === 4) {
          listDataHeader.push('9M ' + this.CurrentYearFillter[2])
          listDataHeader.push('9M ' + this.CurrentYearFillter[3])
        } else if (this.CurrentYearFillter.length !== 4) {
          listDataHeader.push('9M ' + this.CurrentYearFillter[1])
          listDataHeader.push('9M ' + this.CurrentYearFillter[2])
        }
      }

      listDataHeader.push(['Change (%yoy)'])

      ws_data.push([...listDataHeader])

      if (this.popupData.length > 10) {
        this.first5Data2.map(obj => {
          const de = []

          de.push([obj.num], [obj.securitySymbol])

          obj.finAnnual.map(finObj => {
            de.push([finObj.value])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgFullYear])
              break
            case 'profit':
              de.push([obj.profitChgFullYear])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgFullYear])
              break
            case 'deRatio':
              de.push([obj.deChgFullYear]) 
              break
          }

          obj.finCurrent.map(finObj => {
            de.push([finObj])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgYoy])
              break
            case 'profit':
              de.push([obj.profitChgYoy])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgYoy])
              break
            case 'deRatio':
              de.push([obj.deChgYoy])
              break
          }

          ws_data.push(de)
        })

        this.expandData2.map(obj => {
          const de = []

          de.push([obj.num], [obj.securitySymbol])

          obj.finAnnual.map(finObj => {
            de.push([finObj.value])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgFullYear])
              break
            case 'profit':
              de.push([obj.profitChgFullYear])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgFullYear])
              break
            case 'deRatio':
              de.push([obj.deChgFullYear])
              break
          }

          obj.finCurrent.map(finObj => {
            de.push([finObj])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgYoy])
              break
            case 'profit':
              de.push([obj.profitChgYoy])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgYoy])
              break
            case 'deRatio':
              de.push([obj.deChgYoy])
              break
          }

          ws_data.push(de)
        })

        this.last52show.map(obj => {
          const de = []

          de.push([obj.num], [obj.securitySymbol])

          obj.finAnnual.map(finObj => {
            de.push([finObj.value])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgFullYear])
              break
            case 'profit':
              de.push([obj.profitChgFullYear])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgFullYear])
              break
            case 'deRatio':
              de.push([obj.deChgFullYear])
              break
          }

          obj.finCurrent.map(finObj => {
            de.push([finObj])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgYoy])
              break
            case 'profit':
              de.push([obj.profitChgYoy])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgYoy])
              break
            case 'deRatio':
              de.push([obj.deChgYoy])
              break
          }

          ws_data.push(de)
        })

        const tam = []
        tam.push([''], ['Total'])
        switch (this.sectorpopupValue2) {
          case 'sale':
            this.salesTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.saleChgF])
            this.salesTotal2.map(obj => {
              tam.push([obj])
            })
            tam.push([this.saleChgY])
            break
          case 'profit':
            this.profitsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.profitChgF])
            this.profitsTotal2.map(obj => {
              tam.push([obj])
            })
            tam.push([this.profitChgY])
            break
          case 'retainEarning':
            this.retainsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.retainChgF])
            this.retainsTotal2.map(obj => {
              tam.push([obj])
            })
            tam.push([this.retainChgY])
            break
          case 'deRatio':
            this.debsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([null])
            this.debsTotal2.map(obj => {
              tam.push([obj])
            })
            tam.push([null])
            break
        }
        ws_data.push(tam)
      } else if (this.popupData.length <= 10) {
        this.dataLessthanten.map((obj, i) => {
          const de = []
          de.push([i + 1], [obj.securitySymbol])
          obj.finance1.map(finObj => {
            de.push([finObj.value])
          })
          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgFullYear])
              break
            case 'profit':
              de.push([obj.profitChgFullYear])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgFullYear])
              break
            case 'deRatio':
              de.push([obj.deChgFullYear])
              break
          }

          obj.finlast2Year.map(finObj => {
            de.push([finObj])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgYoy])
              break
            case 'profit':
              de.push([obj.profitChgYoy])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgYoy])
              break
            case 'deRatio':
              de.push([obj.deChgYoy])
              break
          }

          ws_data.push(de)
        })

        const tam = []
        tam.push([''], ['Total'])
        switch (this.sectorpopupValue2) {
          case 'sale':

            this.salesTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.saleChgF])

            this.salesTotal2.map(obj => {
              tam.push([obj])
            })
            tam.push([this.saleChgY])
            break
          case 'profit':
            this.profitsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.profitChgF])
            this.profitsTotal2.map(obj => {
              tam.push([obj])
            })
            tam.push([this.profitChgY])
            break
          case 'retainEarning':
            this.retainsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.retainChgF])
            this.retainsTotal2.map(obj => {
              tam.push([obj])
            })
            tam.push([this.retainChgY])
            break
          case 'deRatio':
            this.debsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([null])
            this.debsTotal2.map(obj => {
              tam.push([obj])
            })
            tam.push([null])
            break
        }

        ws_data.push(tam)
      }

      return ws_data

    } else if (!this.quarterData.indexOf(4)) {
      const ws_data = []
      const listSectorHeader = []
      listSectorHeader.push(...[this.marketName + ' : ' + this.indexLevel])
      ws_data.push([...listSectorHeader])

      const listFinancialHeader = []
      if (this.sectorpopupValue2 === 'sale') {
        listFinancialHeader.push(...['Financial : Sales (M.Baht)'])
      } else if (this.sectorpopupValue2 === 'profit') {
        listFinancialHeader.push(...['Financial : Profits (M.Baht)'])
      } else if (this.sectorpopupValue2 === 'retainEarning') {
        listFinancialHeader.push(...['Financial : Retain earnings (M.Baht)'])
      } else if (this.sectorpopupValue2 === 'deRatio') {
        listFinancialHeader.push(...['Financial : Debt to equity ratio (x)'])
      }
      ws_data.push([...listFinancialHeader])

      const listDataHeader = []
      listDataHeader.push(['No.'], ['Securities'])
      this.marketHeadipo.map(obj => {
        listDataHeader.push([obj])
      })
      listDataHeader.push([
        'Y' +
        this.marketHeadipo[this.marketHeadipo.length - 1] +
        '/' +
        this.marketHeadipo[this.marketHeadipo.length - 2] +
        ' (%yoy)'
      ])

      ws_data.push([...listDataHeader])

      if (this.popupData.length > 10) {
        this.first5Data2.map(obj => {
          const de = []

          de.push([obj.num], [obj.securitySymbol])

          obj.finAnnual.map(finObj => {
            de.push([finObj.value])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgFullYear])
              break
            case 'profit':
              de.push([obj.profitChgFullYear])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgFullYear])
              break
            case 'deRatio':
              de.push([obj.deChgFullYear])
              break
          }

          ws_data.push(de)
        })

        this.expandData2.map(obj => {
          const de = []

          de.push([obj.num], [obj.securitySymbol])

          obj.finAnnual.map(finObj => {
            de.push([finObj.value])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgFullYear])
              break
            case 'profit':
              de.push([obj.profitChgFullYear])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgFullYear])
              break
            case 'deRatio':
              de.push([obj.deChgFullYear])
              break
          }

          ws_data.push(de)
        })

        this.last52show.map(obj => {
          const de = []

          de.push([obj.num], [obj.securitySymbol])

          obj.finAnnual.map(finObj => {
            de.push([finObj.value])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgFullYear])
              break
            case 'profit':
              de.push([obj.profitChgFullYear])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgFullYear])
              break
            case 'deRatio':
              de.push([obj.deChgFullYear])
              break
          }

          ws_data.push(de)
        })

        const tam = []
        tam.push([''], ['Total'])
        switch (this.sectorpopupValue2) {
          case 'sale':
            this.salesTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.saleChgF])
            break
          case 'profit':
            this.profitsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.profitChgF])
            break
          case 'retainEarning':
            this.retainsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.retainChgF])
            break
          case 'deRatio':
            this.debsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([null])
            break
        }
        ws_data.push(tam)
      } else if (this.popupData.length <= 10) {
        this.dataLessthanten.map((obj, i) => {
          const de = []
          de.push([i + 1], [obj.securitySymbol])

          obj.finance1.map(finObj => {
            de.push([finObj.value])
          })

          switch (this.sectorpopupValue2) {
            case 'sale':
              de.push([obj.saleChgFullYear])
              break
            case 'profit':
              de.push([obj.profitChgFullYear])
              break
            case 'retainEarning':
              de.push([obj.retainEarningChgFullYear])
              break
            case 'deRatio':
              de.push([obj.deChgFullYear])
              break
          }

          ws_data.push(de)
        })

        const tam = []
        tam.push([''], ['Total'])
        switch (this.sectorpopupValue2) {
          case 'sale':
            this.salesTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.saleChgF])
            break
          case 'profit':
            this.profitsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.profitChgF])
            break
          case 'retainEarning':
            this.retainsTotal.map(obj => {
              tam.push([obj])
            })
            tam.push([this.retainChgF])
            break
          case 'deRatio':
            this.debsTotal.map(obj => {
              tam.push([obj])
            })

            tam.push([null])

            break
        }

        ws_data.push(tam)
      }

      return ws_data
    }
  }

  isPrintData() {
    return this.print
  }

  printData() {
    if (this.print && localStorage.getItem('printSectorPopup') === 'false') {
      window.print()
      localStorage.setItem('printSectorPopup', 'true')
    }
  }

  checkDataLessthan10() {
    if (this.sectorpopupValue1 === 'top') {
      if (this.sortList.length > 10) {
        return true
      } else {
        return false
      }
    } else {
      if (this.popupData.length > 10) {
        return true
      } else {
        return false
      }
    }
  }

  checkDataLessthanten() {
    if (this.sectorpopupValue1 === 'top') {
      if (this.sortList.length <= 10) {
        return true
      } else {
        return false
      }
    } else {
      if (this.popupData.length <= 10) {
        return true
      } else {
        return false
      }
    }
  }

  checkSectorpopupValue() {
    if (this.sectorpopupValue1 === 'trend') {
      return true
    } else {
      return false
    }
  }

  getSectorpopupValue2() {
    switch (this.sectorpopupValue2) {
      case 'sale':
        return 'Financial data : Sales (M.Baht)'
      case 'profit':
        return 'Financial data : Profits (M.Baht)'
      case 'retainEarning':
        return 'Financial data : Retain earnings (M.Baht)'
      case 'deRatio':
        return 'Financial data : Debt to equity ratio (x)'
    }
  }

  getQuarterYear(quarterData, index) {
    if (quarterData.indexOf('1')) {
      return '3M ' + this.headerQuater[index]
    } else if (quarterData.indexOf('2')) {
      return '6M ' + this.headerQuater[index]
    } else if (quarterData.indexOf('3')) {
      return '9M ' + this.headerQuater[index]
    }
  }

  getChgFullYear(sectorpopupValue2, data) {
    switch (sectorpopupValue2) {
      case 'sale':
        return data.saleChgFullYear
      case 'profit':
        return data.profitChgFullYear
      case 'retainEarning':
        return data.retainEarningChgFullYear
      case 'deRatio':
        return null
    }
  }

  getChgYoy(sectorpopupValue2, data) {
    switch (sectorpopupValue2) {
      case 'sale':
        return data.saleChgYoy
      case 'profit':
        return data.profitChgYoy
      case 'retainEarning':
        return data.retainEarningChgYoy
      case 'deRatio':
        return null
    }
  }

  getTotal1(value, chgValue) {
    switch (value) {
      case 'sale':
        if (chgValue === 'ChgF') {
          return this.salesTotal
        } else {
          return this.salesTotal2
        }
      case 'profit':
        if (chgValue === 'ChgF') {
          return this.profitsTotal
        } else {
          return this.profitsTotal2
        }
      case 'retainEarning':
        if (chgValue === 'ChgF') {
          return this.retainsTotal
        } else {
          return this.retainsTotal2
        }
      case 'deRatio':
        if (chgValue === 'ChgF') {
          return this.debsTotal
        } else {
          return this.debsTotal2
        }
    }
  }

  async getLastTradingDate(): Promise<number> {
    const date = await this.cpmService.getLastTradingDate()
    const lastTrading = new Date(date.lastTradingDate.toString())
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }
    let dateTime
    dateTime = lastTrading.toLocaleDateString('en-EN', options)
    this.tradingDate = dateTime
    return lastTrading.getFullYear()
  }

  isPositivenumber(value) {
    let classNameList;
    if (!value || value == '-' || !isNaN(value)) classNameList = 'text-right';
    else classNameList = 'text-center';
    const num = parseFloat(value);
    if (num < 0) classNameList = classNameList + " negative";
    else classNameList = classNameList + " positive";
    return classNameList;
  }

  setChgyoy(list) {
    list = list.map(obj => {
      if (obj.finCurrent[1] === 0) {
        obj.deChgYoy = null;
        obj.profitChgYoy = null;
        obj.retainEarningChgYoy = null;
        obj.saleChgYoy = null;
      }
      return obj;
    })
    return list;
  }

  setfinStatCurrent(currentYearFillter, finStatCurrent) {
    const currentYear = currentYearFillter[currentYearFillter.length - 1];
    if (!finStatCurrent.find(finstat => finstat.year === currentYear)) {
      finStatCurrent.push({
        deRatio: 0,
        ebit: 0,
        profit: 0,
        quarter: null,
        retainEarning: 0,
        sale: 0,
        year: currentYear,

      })
    }

    return finStatCurrent;
  }

  getFinCurrent(data) {
    if (this.sectorpopupValue2 === 'deRatio') {
      if (!!data) {
        if(isNaN(data)) return data;
        else return data.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return '-'
      }
    } else if (this.sectorpopupValue2 !== 'deRatio') {
      if (!!data) {
        if(isNaN(data)) return data;
        else return data.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return '-'
      }
    }
  }

  getFinAnnual(data) {
    if (this.sectorpopupValue2 === 'deRatio') {
      if (!!data) {
        if(isNaN(data)) return data;
        else return data.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return '-'
      }
    } else if (this.sectorpopupValue2 !== 'deRatio') {
      if (!!data) {
        if(isNaN(data)) return data;
        else return data.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return '-'
      }
    }
  }

  getDataTotal(dataTotal) {
    if (!dataTotal || dataTotal === 0 || dataTotal === '-') {
      return '-'
    } else {
      return dataTotal
    }
  }



  checkPopupData() {
    if (this.popupData.length > 0) {
      return true
    } else {
      return false
    }
  }

  getQuarter() {
    if (!this.quarterData.indexOf(1) || !this.quarterData.indexOf(2) || !this.quarterData.indexOf(3)) {
      return true
    } else {
      return false
    }
  }


}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/industry-level/sector-popup-data/sector-popup-data.component.ts